import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const DELETE_CAMPAIGNS = 'DELETE_CAMPAIGNS';
export const SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN';
export const SET_COPY_CURRENT_CAMPAIGN = 'SET_COPY_CURRENT_CAMPAIGN';
export const UNSET_CURRENT_CAMPAIGN = 'UNSET_CURRENT_CAMPAIGN';
export const CLEAR_CAMPAIGN_ERROR = 'CLEAR_CAMPAIGN_ERROR';
export const CLEAR_CAMPAIGN_STORE = 'CLEAR_CAMPAIGN_STORE';

export const GET_ASSOCIATED_CAMPAIGNS_FOR = 'GET_ASSOCIATED_CAMPAIGNS_FOR';

export const GET_PAGINATED_CAMPAIGNS = 'GET_PAGINATED_CAMPAIGNS';

// async actions
export const GETTING_CAMPAIGNS = 'GETTING_CAMPAIGNS';
export const GETTING_CAMPAIGNS_SUCCEEDED = 'GETTING_CAMPAIGNS_SUCCEEDED';
export const GETTING_CAMPAIGNS_FAILED = 'GETTING_CAMPAIGNS_FAILED';

export const GETTING_CAMPAIGN = 'GETTING_CAMPAIGN';
export const GETTING_CAMPAIGN_FAILED = 'GETTING_CAMPAIGN_FAILED';
export const GETTING_CAMPAIGN_SUCCEEDED = 'GETTING_CAMPAIGN_SUCCEEDED';

export const CREATING_CAMPAIGN = 'CREATING_CAMPAIGN';
export const CREATING_CAMPAIGN_SUCCEEDED = 'CREATING_CAMPAIGN_SUCCEEDED';
export const CREATING_CAMPAIGN_FAILED = 'CREATING_CAMPAIGN_FAILED';

export const UPDATING_CAMPAIGN = 'UPDATING_CAMPAIGN';
export const UPDATING_CAMPAIGN_SUCCEEDED = 'UPDATING_CAMPAIGN_SUCCEEDED';
export const UPDATING_CAMPAIGN_FAILED = 'UPDATING_CAMPAIGN_FAILED';

export const DELETING_CAMPAIGNS = 'DELETING_CAMPAIGNS';
export const DELETING_CAMPAIGNS_SUCCEEDED = 'DELETING_CAMPAIGNS_SUCCEEDED';
export const DELETING_CAMPAIGNS_FAILED = 'DELETING_CAMPAIGNS_FAILED';

export const GETTING_ACTIVE_FOR = 'GETTING_ACTIVE_FOR';
export const GETTING_ACTIVE_FOR_SUCCEEDED = 'GETTING_ACTIVE_FOR_SUCCEEDED';
export const GETTING_ACTIVE_FOR_FAILED = 'GETTING_ACTIVE_FOR_FAILED';

export const INITIATE_SAVE_AND_SCHEDULE_NOW = 'INITIATE_SAVE_AND_SCHEDULE_NOW';
export const RESET_SCHEDULE_NOW = 'RESET_SCHEDULE_NOW';

export const GETTING_PAGINATED_CAMPAIGNS = 'GETTING_PAGINATED_CAMPAIGNS';
export const GETTING_PAGINATED_CAMPAIGNS_SUCCEEDED = 'GETTING_PAGINATED_CAMPAIGNS_SUCCEEDED';
export const GETTING_PAGINATED_CAMPAIGNS_FAILED = 'GETTING_PAGINATED_CAMPAIGNS_FAILED';

export const GET_ALL_ACTIVE_CAMPAIGNS = 'GET_ALL_ACTIVE_CAMPAIGNS';
export const GETTING_ALL_ACTIVE_CAMPAIGNS_SUCCEEDED = 'GETTING_ALL_ACTIVE_CAMPAIGNS_SUCCEEDED';
export const GETTING_ALL_ACTIVE_CAMPAIGNS_FAILED = 'GETTING_ALL_ACTIVE_CAMPAIGNS_FAILED';

export const UPDATE_CAMPAIGN_FILTERS = 'UPDATE_CAMPAIGN_FILTERS';
export const SET_CAMPAIGN_FILTERS = 'SET_CAMPAIGN_FILTERS';
export const RESET_CAMPAIGN_FILTERS = 'RESET_CAMPAIGN_FILTERS';

export const GET_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS = 'GET_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS';
export const GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS = 'GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS';
export const GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS_SUCCEEDED = 'GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS_SUCCEEDED';
export const GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS_FAILED = 'GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS_FAILED';

export const getCampaigns = createAction(GET_CAMPAIGNS);

export const getCampaign = createAction(GET_CAMPAIGN);

export const createCampaign = createAction(CREATE_CAMPAIGN);

export const updateCampaign = createAction(UPDATE_CAMPAIGN);

export const deleteCampaigns = createAction(DELETE_CAMPAIGNS);

export const setCurrentCampaign = createAction(SET_CURRENT_CAMPAIGN);

export const setCopyCurrentCampaign = createAction(SET_COPY_CURRENT_CAMPAIGN);

export const unsetCurrentCampaign = createAction(UNSET_CURRENT_CAMPAIGN);

export const clearCampaignError = createAction(CLEAR_CAMPAIGN_ERROR);

export const clearCampaignStore = createAction(CLEAR_CAMPAIGN_STORE);

export const gettingCampaigns = createAction(GETTING_CAMPAIGNS);

export const gettingCampaignsSucceeded = createAction(
  GETTING_CAMPAIGNS_SUCCEEDED
);

export const gettingCampaignsFailed = createAction(GETTING_CAMPAIGNS_FAILED);

export const gettingCampaign = createAction(GETTING_CAMPAIGN);

export const gettingCampaignSucceeded = createAction(
  GETTING_CAMPAIGN_SUCCEEDED
);

export const gettingCampaignFailed = createAction(GETTING_CAMPAIGN_FAILED);

export const creatingCampaign = createAction(CREATING_CAMPAIGN);

export const creatingCampaignSucceeded = createAction(
  CREATING_CAMPAIGN_SUCCEEDED
);

export const creatingCampaignFailed = createAction(CREATING_CAMPAIGN_FAILED);

export const updatingCampaign = createAction(UPDATING_CAMPAIGN);

export const updatingCampaignSucceeded = createAction(
  UPDATING_CAMPAIGN_SUCCEEDED
);

export const updatingCampaignFailed = createAction(UPDATING_CAMPAIGN_FAILED);

export const deletingCampaigns = createAction(DELETING_CAMPAIGNS);

export const deletingCampaignsSucceeded = createAction(
  DELETING_CAMPAIGNS_SUCCEEDED
);

export const deletingCampaignsFailed = createAction(DELETING_CAMPAIGNS_FAILED);

export const initiateSaveAndScheduleNow = createAction(
  INITIATE_SAVE_AND_SCHEDULE_NOW
);
export const resetScheduleNow = createAction(RESET_SCHEDULE_NOW);

export const getAssociatedCampaignsFor = createAction(
  GET_ASSOCIATED_CAMPAIGNS_FOR
);

export const getPaginatedCampaigns = createAction(GET_PAGINATED_CAMPAIGNS);
export const gettingPaginatedCampaigns = createAction(
  GETTING_PAGINATED_CAMPAIGNS
);
export const gettingPaginatedCampaignsSucceeded = createAction(
  GETTING_PAGINATED_CAMPAIGNS_SUCCEEDED
);
export const gettingPaginatedCampaignsFailed = createAction(
  GETTING_PAGINATED_CAMPAIGNS_FAILED
);

export const getAllActiveCampaigns = createAction(GET_ALL_ACTIVE_CAMPAIGNS);
export const getAllActiveCampaignsSucceeded = createAction(GETTING_ALL_ACTIVE_CAMPAIGNS_SUCCEEDED);
export const getAllActiveCampaignsFailed = createAction(GETTING_ALL_ACTIVE_CAMPAIGNS_FAILED);

export const updateCampaignFilters = createAction(UPDATE_CAMPAIGN_FILTERS);
export const setCampaignFilters = createAction(SET_CAMPAIGN_FILTERS);
export const resetCampaignFilters = createAction(RESET_CAMPAIGN_FILTERS);

export const getAdvancedSearchPaginatedCampaigns = createAction(GET_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS);
export const gettingAdvancedSearchPaginatedCampaigns = createAction(
  GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS
);
export const gettingAdvancedSearchPaginatedCampaignsSucceeded = createAction(
  GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS_SUCCEEDED
);
export const gettingAdvancedSearchPaginatedCampaignsFailed = createAction(
  GETTING_ADVANCED_SEARCH_PAGINATED_CAMPAIGNS_FAILED
);